import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { setPageTitle } from '../../redux/slice/pageTitleSlice'
import { useDispatch, useSelector } from 'react-redux'
import {
  allCrudNames,
  allPages,
  checkPageAccess
} from '../../../lib/AllPageNames'
import NotFound from '../../NotFound/NotFound'
import MainOrder from '../OrderList/MainOrder'

const InitiateOrderTabbing = () => {
  const dispatch = useDispatch()
  const { pageAccess } = useSelector((state) => state.user)
  const [activeToggle, setActiveToggle] = useState('initiateList')

  useEffect(() => {
    dispatch(setPageTitle('Initiate List'))
  }, [])

  return checkPageAccess(pageAccess, allPages?.order, allCrudNames?.read) ? (
    <>
      <div className='card overflow-hidden'>
        <div className='card-body p-0'>
          <div className='nav-tabs-horizontal nav nav-tabs'>
            {checkPageAccess(
              pageAccess,
              allPages?.order,
              allCrudNames?.read
            ) && (
              <Link
                onClick={() => setActiveToggle('order')}
                data-toggle='tab'
                className={`nav-link fw-semibold ${
                  activeToggle === 'initiateList' ? 'active show' : ''
                }`}
              >
                <span className='nav-span'>
                  Initiate Order
                  <hr />
                </span>
              </Link>
            )}
          </div>

          <div className='tab-content p-3'>
            {checkPageAccess(
              pageAccess,
              allPages?.order,
              allCrudNames?.read
            ) && (
              <div
                id='order'
                className={`tab-pane fade ${
                  activeToggle === 'initiateList' ? 'active show' : ''
                }`}
              >
                {activeToggle === 'initiateList' && (
                  <MainOrder type='Initiate' />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  ) : (
    <NotFound />
  )
}

export default InitiateOrderTabbing
